import styled from 'styled-components'

const Heading = styled.h3`
  font-size: clamp(2.2rem, 3.2vw, 4rem);
  text-align: center;
`

export default Heading
